import logo from './logo.svg';
import './App.css';
import React, { useState, useEffect } from "react";
import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import 'bootstrap/dist/css/bootstrap.min.css';
import './custom2.css';

import axios from 'axios'
import { RecommendationsAI, RecommendationSummaryAI } from './RecommendationsAI';
import Feedback from './Feedback';
import {API_BASE_PATH} from './Api';


export default function BodyComp() {



  const getOutletInfo = async () => new Promise((res, rej) => {
    axios.get('http://localhost:8080/final_out.json')
      .then(response => {
        const data = response.data;
        res(data)
      })
      .catch(error => {
        console.log(error);
      })
  });

  const getClusterInfo = async () => new Promise((res, rej) => {
    axios.get('http://localhost:8080/cluster_info.json')
      .then(response => {
        const data = response.data;
        res(data)
      })
      .catch(error => {
        console.log(error);
      })
  });




  const [value, setValue] = useState({ value: "x" });
  const [type, setType] = useState({ label: "OutletCode", value: "outletCode" });

  const [rows, setRows] = useState([]);
  const [items, setItems] = useState(['one', 'two', 'three']);
  const [outlets, setOutlets] = useState([]);

  const [recommendations, setRecommendations] = useState([]);
  const [data, setData] = useState({});

  const [clusterInfo, setClusterInfo] = useState({});
  const [recordInfo, setRecordInfo] = useState({});
  const [inValue, setInValue] = useState('');

  const [loading, setLoading] = useState(false);
  const [statusInfo, setStatusInfo] = useState({});


  useEffect(() => {
    getOutletInfo()
      .then(data => {
        const outs1 = [];
        const outs = [];
        const dMap = [];
        for (var k = 0; k < data.length; k++) {
          outs1[data[k].outletCode] = { label: data[k].outletCode, value: data[k].outletCode }
          var cl = (dMap[data[k].outletCode] || []);
          cl.push(data[k]);
          dMap[data[k].outletCode] = cl;
        }
        for (var k in outs1) {
          outs.push(outs1[k]);

        }

        setData(dMap);
        setOutlets(outs);
      }
      );
  }, [])

  const handleChange = (e) => {
    console.log(e)
    items.push(e.value);
    setType(e)
  };

  const getRecommendations = async (inv) => new Promise((res, rej) => {
    const req = {}
    req[type.value] = inv;
    console.log("Fetching recommendations for " + JSON.stringify(req))
    axios.post(API_BASE_PATH+`/recommend`, req)
      .then(response => {
        const data = response.data;
        res(data)
      })
      .catch(error => {
        console.log(error);
      })
  });


  const handleInputChange = e => {
    setInValue(e.target.value);
    setValue({ value:e.target.value })
    setLoading(true)
    getRecommendations(e.target.value).then(recommendations => {
      console.log(recommendations)
      setRecommendations(recommendations);
      setLoading(false)

    })
  };

  const loadOptions = (inputValue) => {
    console.log("Initial value=>" + inputValue + outlets.length)
    if (!inputValue) {
      console.log("Sending default")
      return Promise.resolve(outlets.slice(0, 50));
    }
    //return fetch(`http://jsonplaceholder.typicode.com/posts?userId=${inputValue}`).then(res => res.json());
    return Promise.resolve(outlets.filter(x => x.value.indexOf(inputValue) != -1).slice(0, 50));
  };

  return (
    <div className="container mainPanel" >

      <div className="row">
        <div className="col-md-8 leftPaner" >

          <br></br>


          <div className="row">
            <div className="col-md-3"></div>
            <div className="col-md-3">
              {/* <Select
            value={value}
            onChange={handleChange}
            options={outlets}
          /> */}

              <AsyncSelect

                defaultOptions={[{ label: "OutletCode", value: "outletCode" }, { label: "LoginId", value: "loginId" }, { label: "Distributor Code", value: "dbCode" }]}
                getOptionLabel={e => e.label}
                getOptionValue={e => e.value}
                loadOptions={loadOptions}
                value={type}
                // onInputChange={handleInputChange}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-3">
              <input className="form-control" value={inValue} onChange={handleInputChange}></input>
            </div>
            <div className="col-md-4"></div>
          </div>
          <br></br>
          {
            loading && <h2 style={{ margin: "auto", textAlign: "center" }}>Operation In Progress...........</h2>
          }

          <div className="row" >
            <div className="col-md-6">
              <RecommendationsAI recommendations={recommendations} />
            </div>
            <div className="col-md-6">
              <RecommendationSummaryAI recommendations={recommendations} recordInfo={recordInfo} />
            </div>
          </div>
        </div>
        <div className="col-md-4 rightPanel">
        <Feedback selectedItem={value} statusInfo={statusInfo} updater={setStatusInfo} loading={setLoading}/>
        </div>

      </div>
    </div>
  );
}

